import useLogout from "api/UserResource/useLogout";
import avatarPlaceholder from "assets/images/avatar.jpg";
import { Menu } from "primereact/menu";
import { useRef, useState } from "react";
import { AiOutlineLogout } from "react-icons/ai";
import { useHistory } from "react-router-dom";
import useAuthStore from "store/authStore";
import { FiPlus } from "react-icons/fi";
import useCheckIfUserIsSubscribed from "api/SubscriptionsResource/useCheckIfUserIsSubscribed";
import AddSeatsModal from "components/AddSeatsModal";
import { Role } from "utils/server-constants/roles";

const ProfileIcon = () => {
	const menu = useRef(null);
	const [showAddSeatsModal, setShowAddSeatsModal] = useState(false);

	const history = useHistory();

	// const { data: user, isLoading: isProfileLoading } = useProfile();
	const userProfile = useAuthStore((state) => state.userProfile);
	const hasRoles = useAuthStore((state) => state.hasRoles);

	const { data: isSubscribed } = useCheckIfUserIsSubscribed();
	const currentSubscription = isSubscribed?.data || null;
	const isInstitutional = currentSubscription?.category === "institution";
	const canAddSeats = isInstitutional && hasRoles([Role.Institution, Role.Educator]);

	const { mutateAsync } = useLogout();
	const handleLogout = async () => {
		await mutateAsync();
	};

	const items = [
		{
			label: (
				<div className="flex flex-col">
					<span className="font-bold">
						{userProfile?.first_name} {userProfile?.last_name}
					</span>
					<span className="text-sm">{userProfile?.email}</span>
					<span className="text-xs text-akgreen">My account</span>
				</div>
			),
			command: () => {
				history.push("/my-account");
			},
		},
		...(canAddSeats
			? [
					{
						label: (
							<span className="flex items-center text-akgreen gap-2 font-semibold">
								<FiPlus size={18} />
								Add Seats
							</span>
						),
						command: () => {
							setShowAddSeatsModal(true);
						},
					},
			  ]
			: []),
		{
			label: (
				<span className="flex items-center text-akgreener gap-1">
					Logout
					<AiOutlineLogout size={20} />
				</span>
			),
			command: () => {
				handleLogout();
			},
		},
	];

	return (
		<>
			<button
				type="button"
				onClick={(event) => menu.current.toggle(event)}
				aria-controls="profile_menu"
				aria-haspopup
				className="rounded-full flex justify-center items-center h-7 w-7"
			>
				<img
					src={userProfile?.avatar || avatarPlaceholder}
					width={20}
					alt="Avatar"
					className="rounded-full border-2 border-akgreener h-7 w-7"
				/>
			</button>

			<Menu
				className="font-sans min-w-max"
				model={items}
				popup
				ref={menu}
				id="profile_menu"
			/>

			{canAddSeats && (
				<AddSeatsModal
					visible={showAddSeatsModal}
					onHide={() => setShowAddSeatsModal(false)}
					subscription={currentSubscription}
				/>
			)}
		</>
	);
};

export default ProfileIcon;
